<script setup>
const IconIllustrationGeneric = defineAsyncComponent(() => import('~icons/illustration/generic'));

defineProps({
  title: {
    type: String,
    default: null,
  },
});
</script>

<template>
  <div class="flex items-center">
    <IconIllustrationGeneric class="h-24 w-24" />
    <div class="">
      <div class="text-base font-medium mb-1 text-gray-900">
        {{ title || $t('No data present') }}
      </div>
      <div class="text-sm text-gray-500">
        {{ $t('There are no data to display here') }}
      </div>
    </div>
  </div>
</template>
